export function fmtAmount(amountMinor: number, currency: string): string {
  const major = (amountMinor || 0) / 100;
  const opts = { minimumFractionDigits: 0, maximumFractionDigits: 2 };
  if (currency === 'RUB') return '₽ ' + major.toLocaleString('ru-RU', opts);
  if (currency === 'ILS') return '₪ ' + major.toLocaleString('ru-RU', opts);
  return major.toLocaleString('ru-RU', opts);
}

export function fmtAmountPlain(amountMinor: number): string {
  return ((amountMinor || 0) / 100).toLocaleString('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

export function relativeTime(isoStr: string): string {
  const d = new Date(isoStr);
  const s = (Date.now() - d.getTime()) / 1000;
  if (s < 60) return 'только что';
  if (s < 3600) return Math.floor(s / 60) + ' мин назад';
  if (s < 86400) return Math.floor(s / 3600) + ' ч назад';
  if (s < 86400 * 30) return Math.floor(s / 86400) + ' д назад';
  return d.toLocaleDateString('ru-RU', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function fmtDate(isoStr: string): string {
  const d = new Date(isoStr);
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  return `${dd}.${mm}.${yyyy}`;
}

export function fmtDateTime(isoStr: string): string {
  const d = new Date(isoStr);
  return (
    d.toLocaleDateString('ru-RU', { day: '2-digit', month: 'short' }) +
    ', ' +
    d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })
  );
}
